import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import CustomSelect from '../../../components/Select/CustomSelect';
import Card from '../../../components/Card/Card';
import getBrandList from '../../../thunks/general/getBrandList';

const cardBodyClassName = 'px-[30px] pb-[30px]';
const cardContainerClassName = 'flex-none mb-[40px]';

const ArticlesBrand = ({ value, onSelect }) => {
  const dispatch = useDispatch();
  const { brandList, brandListLoading } = useSelector((state) => ({
    brandList: state?.getBrandList.data,
    brandListLoading: state?.getBrandList.loading
  }), shallowEqual);

  useEffect(() => {
    if (!brandList.length && !brandListLoading) {
      dispatch(getBrandList());
    }
  }, []);

  return (
    <Card
      headerTitle="Brand"
      showHeader
      styleBodyContainer={cardBodyClassName}
      styleContainer={cardContainerClassName}
      headerBordered={false}
      required
    >
      <CustomSelect
        options={brandList}
        isSearchable
        placeholder={brandListLoading ? 'Loading...' : 'Select brand'}
        onChange={onSelect}
        value={value}
        isDisabled={brandListLoading}
        isMulti
        maxSelectedValue={5}

      />
    </Card>
  );
};

ArticlesBrand.propTypes = {
  value: PropTypes.arrayOf(PropTypes.shape({})),
  onSelect: PropTypes.func,
};

ArticlesBrand.defaultProps = {
  onSelect: () => {},
  value: null
};

export default ArticlesBrand;
